export enum BookingStatus {
  Pending = "Pending",
  Completed = "Completed",
  Cancelled = "Cancelled",
}

export enum BookingScope {
  Private = "Private",
  Open = "Open",
}

export enum BookingType {
  Training = "Training",
  Friendly = "Friendly",
  Tournament = "Tournament",
}

export enum BookingMode {
  Free = "Free",
  Slots = "Slots",
}
